module.exports = __webpack_public_path__ + "img/paciente.b28e86e4.png";